import { j as r } from "../../jsx-runtime-B6kdoens.js";
import { useMemo as C, useState as h, useCallback as w } from "react";
import { a as b } from "../../index-CROKJrb5.js";
import { c as g, f as j } from "../../create-component-CBAeEoQ6.js";
import { Button as c } from "../Button/index.js";
import { Typography as k } from "../Typography/index.js";
import { u as y } from "../../use-breakpoints-Kqi6S3m8.js";
import { CrossIcon as B } from "../Icon/icons/CrossIcon/index.js";
const E = g(
  "CookieConsentBanner",
  j(
    ({ as: m, children: a, className: l, onAccept: e, ...i }, n) => {
      const { isXSmall: o, isSmall: s } = y(), t = C(
        () => o || s ? "sm" : "md",
        [o, s]
      ), [p, f] = h(!0), x = m || "div", u = w(
        (d) => {
          f(!1), e == null || e(d);
        },
        [e]
      );
      return p ? /* @__PURE__ */ r.jsx(
        x,
        {
          ref: n,
          className: b(
            "cur-fixed cur-bottom-0 cur-left-0 cur-w-full cur-bg-surface-neutral",
            l
          ),
          role: "region",
          "aria-label": "Cookie Banner",
          ...i,
          children: /* @__PURE__ */ r.jsxs("div", { className: "cur-relative cur-mx-auto cur-flex cur-w-full cur-max-w-7xl cur-flex-col cur-items-center cur-gap-2 cur-px-4 cur-py-2 md:cur-flex-row md:cur-pr-[3.5rem]", children: [
            /* @__PURE__ */ r.jsx(
              k,
              {
                size: "meta",
                className: "cur-flex-1 cur-pr-12 md:cur-pr-0",
                children: a
              }
            ),
            /* @__PURE__ */ r.jsx(
              c,
              {
                onClick: u,
                buttonType: "secondary",
                size: t,
                className: "cur-w-full cur-shrink-0 cur-grow md:cur-max-w-[10rem] md:cur-grow-0",
                children: "OK"
              }
            ),
            /* @__PURE__ */ r.jsx(
              c,
              {
                onClick: u,
                buttonType: "text",
                size: t,
                icon: /* @__PURE__ */ r.jsx(B, {}),
                title: "Close",
                className: "cur-absolute cur-right-1 cur-top-1 md:cur-right-0 md:cur-top-2"
              }
            )
          ] })
        }
      ) : null;
    }
  )
);
export {
  E as CookieConsentBanner
};
//# sourceMappingURL=index.js.map
